import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
const { createFragmentContainer, graphql } = require('react-relay/compat');

import EmailIcon from 'dibs-vg/dist/react/email';
import styles from './ContactDealerProcurementCta.scss';
import TradeProcurementRenderer from './TradeProcurementRenderer';

class ContactDealerProcurementCta extends Component {
    constructor() {
        super();

        this.state = {
            isOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    openModal(event) {
        event.preventDefault();
        this.setState({
            isOpen: true,
        });
    }
    closeModal() {
        this.setState({
            isOpen: false,
        });
    }
    render() {
        const { isOpen } = this.state;
        const { item, copy } = this.props;
        const itemId = get(item, 'serviceId');

        if (!itemId) {
            return null;
        }

        return (
            <div className="contact-dealer-sidebar-wrapper">
                <span>
                    {copy.title && <div className={styles.title}>{copy.title}</div>}
                    <div className={styles.outsideSalesDescription}>
                        {copy.contactUsDescription}
                    </div>
                    <a href="#" className={styles.outsideSalesCTA} onClick={this.openModal}>
                        <EmailIcon className={styles.emailIcon} />
                        {copy.contactUs}
                    </a>
                </span>
                <TradeProcurementRenderer
                    isOpen={isOpen}
                    closeModal={this.closeModal}
                    itemIds={[itemId]}
                    isRemoveContactDealerCTATestRunning
                />
            </div>
        );
    }
}

ContactDealerProcurementCta.propTypes = {
    item: PropTypes.object,
    copy: PropTypes.object,
};

export default createFragmentContainer(ContactDealerProcurementCta, {
    item: graphql`
        fragment ContactDealerProcurementCta_item on Item {
            serviceId
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeProcurement/ContactDealerProcurementCta.jsx